module.exports = __webpack_public_path__ + "img/badge_salabam_vadobay.985cf346.jpg";